import { createContext, useContext } from "react";

export type InteractionSidebarPayload = {
  pgaId?: string;
  defaultJobPostId?: string;
};

type SidebarPayloadMap = {
  [SideBar.CREATE_GLOBAL_INTERACTION]?: InteractionSidebarPayload;
};

export type SidebarPayload = SidebarPayloadMap[keyof SidebarPayloadMap];

type Value = {
  currentSidebar?: SideBar;
  sidebarPayload?: SidebarPayload;
  showSidebar(sidebar: SideBar, payload?: SidebarPayload): () => void;
  toggleSidebar(sidebar: SideBar): (show: boolean) => void;
};

const TopActionBarContext = createContext<Value>({ showSidebar: () => () => {}, toggleSidebar: () => () => {} });

export const useTopActionBar = () => useContext(TopActionBarContext);
export enum SideBar {
  CREATE_GLOBAL_INTERACTION,
  CREATE_GLOBAL_NOTE,
  CREATE_GLOBAL_TASK
}

export default TopActionBarContext;
